var _rect, _rect2, _g, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 846,
    transform: "translate(-120 -480)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 0H4.16797C3.70964 0 3.33464 0.375 3.33464 0.833333C3.33464 1.29167 3.70964 1.66667 4.16797 1.66667H15.8346C16.293 1.66667 16.668 1.29167 16.668 0.833333C16.668 0.375 16.293 0 15.8346 0ZM4.16797 20H15.8346C16.293 20 16.668 19.625 16.668 19.1667C16.668 18.7083 16.293 18.3333 15.8346 18.3333H4.16797C3.70964 18.3333 3.33464 18.7083 3.33464 19.1667C3.33464 19.625 3.70964 20 4.16797 20ZM16.668 3.33333H3.33464C2.41797 3.33333 1.66797 4.08333 1.66797 5V15C1.66797 15.9167 2.41797 16.6667 3.33464 16.6667H16.668C17.5846 16.6667 18.3346 15.9167 18.3346 15V5C18.3346 4.08333 17.5846 3.33333 16.668 3.33333ZM10.0013 5.625C11.0346 5.625 11.8763 6.46667 11.8763 7.5C11.8763 8.53333 11.0346 9.375 10.0013 9.375C8.96797 9.375 8.1263 8.53333 8.1263 7.5C8.1263 6.46667 8.96797 5.625 10.0013 5.625ZM14.168 14.1667H5.83464V12.9167C5.83464 11.525 8.60964 10.8333 10.0013 10.8333C11.393 10.8333 14.168 11.525 14.168 12.9167V14.1667Z",
    fill: "#2E2B2E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -264.5,
    width: 379,
    height: 530,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnContacts);
export default __webpack_public_path__ + "static/media/icn_contacts.5570df105b12bb8e4d5ec3661b8b4524.svg";
export { ForwardRef as ReactComponent };